import { VALIDATION_MESSAGES, REGEX_PATTERNS } from 'eebac/constants';

const FIELDS = {
    firstName: {
        type: "input",
        label: "First Name",
        isRequired: true,
        shoudlAddToTable : true,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            length: {
                minimum: 2, maximum: 255
            },
            format: {
                message: VALIDATION_MESSAGES.INVALID_ONLY_ALPHA_ALLOWED,
                pattern: REGEX_PATTERNS.ONLY_ALPHA
            }
        }
    },
    lastName: {
        type: "input",
        label: "Last Name",
        shoudlAddToTable : true,
        isRequired: true,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            length: {
                minimum: 2, maximum: 255
            },
            format: {
                message: VALIDATION_MESSAGES.INVALID_ONLY_ALPHA_ALLOWED,
                pattern: REGEX_PATTERNS.ONLY_ALPHA
            }
        }
    },
    designation: {
        type: "input",
        label: "Designation",
        isRequired: true,
        shoudlAddToTable : true,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            length: {
                minimum: 2, maximum: 45
            },
            format: {
                message: VALIDATION_MESSAGES.INVALID_ONLY_ALPHA_NUMBERS_SPACES_ALLOWED,
                pattern: REGEX_PATTERNS.ONLY_ALPHA_SPACES
            }
        }
    },
    email: {
        type: "input",
        label: "Email",
        shoudlAddToTable : true,
        isRequired: true,
        disabled: true
    },
    mobileNumber: {
        type: "input",
        label: "Mobile Number",
        shoudlAddToTable : true,
        disabled: true,
        isRequired: true
    },
    password: {
        type: "password",
        label: "Password",
        validations: {
            format: {
                message: VALIDATION_MESSAGES.PASSWORD,
                pattern: REGEX_PATTERNS.PASSWORD
            }
        }
    },
};

export default FIELDS;